import React from "react";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import _ from "lodash";

import { useMount } from "@sportal/cdk/hooks";
import { history } from "./history";
import { AuthRouter } from "./AuthRouter";
import { withWizardGuard } from "./guards/withWizardGuard";
import { withAuthGuard } from "./guards/withAuthGuard";
import { withSettingsGuard } from "./guards/withSettingsGuard";
import { withAccountGuard } from "./guards/withAccountGuard";
import { withAttributesGuard } from "./guards/withAttributesGuard";

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function handleHashChange() {
  const hashPath = window.location.hash.replace("#", "");
  const encodedHashPath = addLeadingSlash(hashPath);

  if (hashPath !== encodedHashPath) {
    const state = window.history.state || { idx: 0 };
    const newPath = window.location.pathname + "#" + encodedHashPath;
    const popStateEvent = new PopStateEvent("popstate", state);

    window.history.replaceState(state, "", newPath);
    dispatchEvent(popStateEvent);
  }
}

export const AppRouter = ({ children }) => {
  useMount(() => {
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => window.removeEventListener("hashchange", handleHashChange);
  });

  return <HistoryRouter history={history} children={children} />;
};

const withInitialData = _.flowRight([
  withAuthGuard,
  withSettingsGuard,
  withAccountGuard,
  withAttributesGuard,
  withWizardGuard,
]);

export const AppRouterRoutes = withInitialData(() => <AuthRouter />);
